import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { NdvrEmploymentStatus } from '@ndvr/customer-api';

import { FormSelect, FormToggle, getFieldName } from 'widgets';

export const PersonAdvancedBlock = ({ prefix }: { prefix?: string }) => {
    const { watch, setValue } = useFormContext();
    const ndvrEmployee = watch(getFieldName('ndvrEmployee', prefix));

    useEffect(() => {
        if (!ndvrEmployee) {
            setValue(getFieldName('ndvrEmploymentStatus', prefix), undefined, {
                shouldDirty: true,
                shouldValidate: true,
            });
        }
    }, [ndvrEmployee, prefix, setValue]);

    return (
        <>
            <FormToggle
                name={getFieldName('ndvrEmployee', prefix)}
                label="Claro Employee"
                description="Leave this on when switching to Former Employee"
            />
            {ndvrEmployee && (
                <FormSelect name={getFieldName('ndvrEmploymentStatus', prefix)} label="Status*">
                    <option></option>
                    <option value={NdvrEmploymentStatus.CURRENT_EMPLOYEE}>Current Employee</option>
                    <option value={NdvrEmploymentStatus.FORMER_EMPLOYEE}>Former Employee</option>
                </FormSelect>
            )}
        </>
    );
};
